import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Form } from "react-bootstrap";
import Layout from "../page/layout";
import { IoBasket, IoBus, IoCheckmarkDoneCircle } from "react-icons/io5";

const DetailHistoryOrder = () => {
  const { id } = useParams(); 
  const { role } = useSelector((state) => state.auth);
  const [order, setOrder] = useState(null); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 

  const token = localStorage.getItem("token"); 

  useEffect(() => {
    if (!token) {
      setError("Token tidak ditemukan");
      setLoading(false);
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:8000/historyorder",
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );

        console.log("Data yang diterima dari API: ", response.data); 
        const orderData = response.data.find((o) => o.uuid === id);

        if (orderData) {
          setOrder(orderData);
        } else {
          setError("Order tidak ditemukan");
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
        setError("Terjadi kesalahan saat mengambil data");
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id, token]);

  if (loading) return <p>Loading...</p>;

  if (error) return <p>{error}</p>;

  const maxLength = Math.max(
    order.limbah_petanis?.[0]?.catatanLimbahBatang.length,
    order.limbah_petanis?.[0]?.catatanLimbahDaun.length,
    order.limbah_petanis?.[0]?.catatanLimbahAkar.length
  );
  return (
    <Layout>
      <Container className="mt-4">
        <h2 className="mb-3">
          <strong>Detail Order Panen : {order.uuid}</strong>
        </h2>
        <Row className="mb-4 text-center">
          <Col md={4} className="border-end">
            <h3>
              <IoBasket />
            </h3>
            <h5 className="fw-bold">Panen</h5>
            <p>{order.tanggalPemanenan}</p>
          </Col>
          <Col md={4} className="border-end">
            <h3>
              <IoBus />
            </h3>
            <h5 className="fw-bold">Pengiriman</h5>
            <p>{order.data_transaksilgs?.[0]?.tanggalPengiriman}</p>
            <p>{order.data_transaksilgs?.[0]?.waktuPengiriman}</p>
            <p>
              Estimasi Tiba: {order.data_transaksilgs?.[0]?.estimasiWaktuTiba}
            </p>
          </Col>
          <Col md={4}>
            <h3>
              <IoCheckmarkDoneCircle />
            </h3>
            <h5 className="fw-bold">Diterima</h5>
            <p>{order.data_transaksilgs?.[0]?.aktualWaktuTiba}</p>
            <p>{order.data_transaksilgs?.[0]?.catatanEfisiensiRute}</p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <h5 className="fw-bold">Order Selesai</h5>
            <p>At {order.data_transaksiprs?.[0]?.tanggalselesai}</p>
          </Col>

          <Col md={6}>
            <h5 className="fw-bold">Tanggal Penerimaan</h5>
            <p>{order.data_transaksipbks?.[0]?.tanggalPenerimaan}</p>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>ID Lahan</Form.Label>
              <Form.Control readOnly value={order.idLahan} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Varietas Singkong</Form.Label>
              <Form.Control readOnly value={order.varietasSingkong} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Berat Aktual (kg)</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksipbks?.beratTotalDiterima}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Harga Aktual (Rp)</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksiprs?.[0]?.hargaaktual.toLocaleString(
                  "id-ID"
                )}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Catatan Harga</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksiprs?.[0]?.catatanharga}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Kondisi Pengiriman</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksilgs?.[0]?.kondisiPengiriman}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Biaya Transportasi (Rp)</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksilgs?.[0]?.biayaTransportasi}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan dari Penerima</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksilgs?.[0]?.catatanDariPenerima}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan Kualitas</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksipbks?.[0]?.catatanKualitas}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Evaluasi Kualitas</Form.Label>
              <Form.Control
                readOnly
                value={order.data_transaksipbks?.[0]?.evaluasiKualitas}
              />
            </Form.Group>
          </Col>
        </Row>

        {order.limbah_petanis?.length >= 0 && (
          <Row>
            <h5 className="fw-bold">Data Limbah</h5>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Batang (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={order.limbah_petanis?.[0]?.beratLimbahBatang || "-"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Daun (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={order.limbah_petanis?.[0]?.beratLimbahDaun || "-"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Akar (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={order.limbah_petanis?.[0]?.beratLimbahAkar || "-"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Batang</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={order.limbah_petanis?.[0]?.catatanLimbahBatang || "-"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Daun</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={order.limbah_petanis?.[0]?.catatanLimbahDaun || "-"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Akar</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={order.limbah_petanis?.[0]?.catatanLimbahAkar || "-"}
                />
              </Form.Group>
            </Col>
          </Row>
        )}
      </Container>
    </Layout>
  );
};

export default DetailHistoryOrder;
